<div class="logo">
    <img alt="Coca Cola" class="coca-cola-image" src="assets/images/coca-cola-logo.svg"/>
    
    <div class="divider"></div>

    <div class="audit-portal">
        <img alt="Audit Portal" class="icon-image" src="assets/images/logo-icon.svg"/>

        <p class="text">
            @if (view === 'latam') {
                <strong>Latam Promotions</strong> Portal
            } @else {
                <strong>Audit</strong> Portal
            }
        </p>
    </div>
</div>
